export default function PartnerIntroSectionFr() {
  const benefits = [
    {
      icon: 'ri-truck-line',
      title: 'Logistique consolidée',
      desc: 'Livraison en un seul point et gestion des stocks — nous gérons la complexité pour que vous puissiez vous concentrer sur la production.',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Efficacité financière',
      desc: 'Gestion des créances et regroupement de la demande qui réduisent votre charge administrative et améliorent votre flux de trésorerie.',
    },
    {
      icon: 'ri-global-line',
      title: 'Représentation professionnelle',
      desc: 'Communication bilingue et disponibilité 24/7 selon les fuseaux horaires — le pont professionnel que vos clients attendent.',
    },
  ];

  return (
    <section className="w-full px-6 md:px-16 py-16 bg-white border-b border-stone-100">
      <div className="max-w-5xl mx-auto">
        <div className="mb-4">
          <span className="text-emerald-700 text-xs font-bold uppercase tracking-widest block mb-3">
            Partenariat
          </span>
          <h2
            className="text-3xl md:text-4xl font-extrabold text-stone-900 leading-tight mb-5"
            style={{ fontFamily: "'DM Serif Display', serif" }}
          >
            Simplifiez votre accès au marché
          </h2>
        </div>

        <p className="text-stone-600 text-base leading-relaxed max-w-3xl mb-12">
          Que vous cherchiez à pénétrer de nouveaux territoires ou à optimiser la gestion de vos clients existants,
          <strong className="text-stone-800"> MAX-Sourcing est votre partenaire stratégique.</strong> Nous offrons
          un soutien de bout en bout qui élimine les frictions de votre chaîne d&apos;approvisionnement et place vos produits
          devant les bons acheteurs — efficacement et professionnellement.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {benefits.map(({ icon, title, desc }) => (
            <div
              key={title}
              className="rounded-lg border border-stone-100 bg-stone-50 p-6 flex flex-col gap-4"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-emerald-100">
                <i className={`${icon} text-emerald-700 text-xl`} />
              </div>
              <div>
                <h4 className="text-sm font-bold text-stone-900 mb-1">{title}</h4>
                <p className="text-xs text-stone-500 leading-relaxed">{desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="rounded-lg bg-emerald-700 px-8 py-7 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5">
          <div>
            <p className="text-white font-bold text-base leading-snug mb-1">
              Prêt à valoriser votre chaîne d&apos;approvisionnement ?
            </p>
            <p className="text-emerald-100 text-sm leading-relaxed max-w-xl">
              Contactez-nous dès aujourd&apos;hui pour découvrir comment nous pouvons fournir le pont professionnel et la réactivité que vos clients attendent.
            </p>
          </div>
          <a
            href="#supplier-application-form-fr"
            className="whitespace-nowrap bg-white text-emerald-800 text-sm font-bold px-7 py-3 rounded-md hover:bg-emerald-50 transition-colors cursor-pointer"
          >
            Postuler maintenant
          </a>
        </div>
      </div>
    </section>
  );
}
